import React, { Fragment } from 'react';
import styled from 'styled-components';
import Correct from '../Validation/correct';
import Wrong from '../Validation/wrong';
import CountryDropdown from '../CountryDropdown/dropdown';

const InputHeight = styled.div`
  margin-bottom: 24px;
  color: var(--inputTxtColor);
  position: relative;
  width: 100%;
`;

const InputField = styled.input`
  font-size: 14px;
  width: 100%;
  height: 40px;
  color: ${(props) => (props.darkTheme && props.isFromModal ? props.theme.txtPrimary : props.darkTheme ? props.theme.inputsColor : 'var(--inputTxtColor)')};
  background: ${(props) =>
    props.disabled && props.darkTheme
      ? props.theme.selectionBg
      : props.disabled && !props.darkTheme
      ? 'var(--light)'
      : props.darkTheme && props.isFromModal
      ? 'var(--dark)'
      : props.darkTheme
      ? props.theme.cardBg
      : '#fff'};
  border: 1px solid ${(props) => (props.darkTheme ? props.theme.borderColor : 'var(--greyBorderColor)')};
  border-radius: 4px;
  padding-left: 10px;
  cursor: ${(props) => props.disabled && 'not-allowed'};
  :hover {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '1px solid var(--brandColor)'};
  }
  :focus {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '2px solid var(--brandColor)'};
  }
  @media (min-width: 768px) {
    padding-left: 12px;
  }
`;

const PhoneNumberDiv = styled.div`
  display: grid;
  grid-template-columns: 30% 66%;
  justify-content: space-between;
`;

export const SignupInput = ({ containerStyle, style, labelAvailable, label, type, value, onChange, placeholder, error, required, maxLength, recurringPaid, autofocus }) => (
  <InputHeight style={containerStyle}>
    {labelAvailable ? (
      <Fragment>
        <label style={{ marginBottom: '10px' }}>
          {label}
          <span style={{ color: 'var(--danger)' }}>{required ? ' *' : ''}</span>
        </label>
        <br />
      </Fragment>
    ) : (
      ''
    )}
    <InputField
      style={style}
      maxLength={maxLength}
      error={error}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={recurringPaid}
      autoFocus={autofocus}
    />
    {error ? <Wrong /> : error === false && <Correct />}
  </InputHeight>
);

export const Input = ({
  containerStyle,
  style,
  maxLength,
  labelAvailable,
  label,
  type,
  value,
  onChange,
  placeholder,
  error,
  required,
  isDisable,
  autofocus,
  inputRef,
  darkTheme,
  isFromModal,
  ...props
}) => (
  <InputHeight style={containerStyle}>
    {labelAvailable ? (
      <Fragment>
        <label style={{ marginBottom: '10px' }}>
          {label}
          <span style={{ color: 'var(--danger)' }}>{required ? ' *' : ''}</span>
        </label>
        <br />
      </Fragment>
    ) : (
      ''
    )}
    <InputField
      maxLength={maxLength}
      style={style}
      type={type || 'text'}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      error={error}
      disabled={isDisable}
      autoFocus={autofocus}
      required={required}
      ref={inputRef}
      darkTheme={darkTheme}
      isFromModal={isFromModal}
      {...props}
    />
  </InputHeight>
);

export const EditProfileInput = ({ style, type, value, onChange, placeholder, error, darkTheme, isFromModal, ...props }) => (
  <InputField
    style={style}
    type={type || 'text'}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    error={error}
    darkTheme={darkTheme}
    isFromModal={isFromModal}
    {...props}
  />
);

const PhoneNumberInput = ({
  containerStyle,
  style,
  maxLength,
  labelAvailable,
  label,
  type,
  phoneNo,
  setValue,
  placeholder,
  error,
  required,
  setPhoneCode,
  phoneCode,
  from,
  autofocus,
  isFromModal,
  darkTheme,
  ...props
}) => (
  <InputHeight style={containerStyle}>
    {labelAvailable ? (
      <Fragment>
        <label style={{ marginBottom: '10px' }}>
          {label}
          <span style={{ color: 'var(--danger)' }}> {required ? ' *' : ''} </span>
        </label>
        <br />
      </Fragment>
    ) : (
      ''
    )}
    <PhoneNumberDiv from={from}>
      <CountryDropdown from={from} setPhoneCode={setPhoneCode} phoneCode={phoneCode} darkTheme={darkTheme} isFromModal={isFromModal} />
      <InputField
        maxLength={maxLength}
        style={style}
        type={type || 'text'}
        value={phoneNo}
        onChange={(e) => setValue('phoneNo', e.target.value, e)}
        placeholder={placeholder}
        error={error}
        from={from}
        autoFocus={autofocus}
        darkTheme={darkTheme}
        isFromModal={isFromModal}
        {...props}
      />
    </PhoneNumberDiv>
  </InputHeight>
);

export default PhoneNumberInput;
